export class ClaimsFilterDateType {
  name: string;
  selected: boolean;
  display: boolean;

  constructor(name: string, selected: boolean = false, display = true) {
    this.name = name;
    this.selected = selected;
    this.display = display;
  }
}

export class ClaimsFilterStatusType {
  name: string;
  selected: boolean;
  display: boolean;

  constructor(name: string, selected: boolean = false, display = true) {
    this.name = name;
    this.selected = selected;
    this.display = display;
  }
}

export class ClaimsFilter {
  month: ClaimsFilterDateType[];
  status: ClaimsFilterStatusType[];

  constructor(month: ClaimsFilterDateType[] = [], status: ClaimsFilterStatusType[] = []) {
    this.month = month;
    this.status = status;
  }
}
